import React, {useState, useEffect} from 'react';
import axios from 'axios';
import Select from 'react-select';
import './AddressingPopup.css';
import {IoIosCloseCircle} from 'react-icons/io';
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import CustomAlert from "../../../components/ConfirmationModal/CustomAlert";
import {jwtDecode} from "jwt-decode";
import AddNewCaseViewerEnum from "../../../enums/AddNewCaseViewer";
import CaseUserStatus from "../../../enums/CaseUserStatus";
import {FaUserPlus} from "react-icons/fa";
import {Checkbox, Tooltip} from "@mui/material";
import approverStatusEnum from "../../../enums/approverStatusEnum";
import CaseNotificationEnum from "../../../enums/CaseNotiFicationEnum";

const AddressingPopupViewer = ({roleName, onManagerAdded, fileId, internalUsers, groupId}) => {
    const token = localStorage.getItem('jwtToken');
    const decodedToken = jwtDecode(token);
    const userId = decodedToken.sub;
    const [userViewers, setUserViewers] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [alertInfo, setAlertInfo] = useState({show: false, message: '', type: ''});
    const [selectedUserViewerOptions, setSelectedUserViewerOptions] = useState([]);
    const [selectedViewerDepartment] = useState(null);


    const handleChangeCheckbox = (userId, checkboxType) => {
        setSelectedUserViewerOptions(prevOptions =>
            prevOptions.map(option => {
                if (option.value === userId) {
                    if (checkboxType === approverStatusEnum.worker ) {
                        return {
                            ...option,
                            isCheckedApprover: false,
                            approverStatus: checkboxType
                        };
                    }
                   else if (checkboxType === approverStatusEnum.viewer ) {
                        return {
                            ...option,
                            isCheckedApprover: false,
                            approverStatus: checkboxType
                        };
                    }
                    else if (checkboxType === approverStatusEnum.visager ) {
                        return {
                            ...option,
                            isCheckedApprover: true,
                            approverStatus: checkboxType
                        };
                    }
                    else {
                        return {
                            ...option,
                            isCheckedApprover: false,
                            approverStatus: checkboxType === approverStatusEnum.visager
                        };
                    }
                } else {
                    if (checkboxType === approverStatusEnum.worker && option.approverStatus === approverStatusEnum.worker) {
                        return {
                            ...option,
                            approverStatus: approverStatusEnum.viewer
                        };
                    }

                }
                return option;
            })
        );
    };



    const rolesInGeorgian = {
        'HeadOfAgency': "სააგენტოს უფროსი",
        'DeputyHeadOfAgency': "უფროსის მოადგილე",
        'HeadOfDepartment': "სამმართველოს უფროსი",
        'Expert': "სპეციალისტი"
    };

    const fetchUserDetails = async (userId) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/User/GetOneUserByID?UserID=${userId}`);
            const data = response.data;
            return data.data;
        } catch (error) {
            return null;
        }
    };

    useEffect(() => {
        if (roleName === "HEADOFDEPARTMENT") {
            const getUserDetails = async () => {
                const headOfDepartmentInfo = await fetchUserDetails(userId);
                if (headOfDepartmentInfo) {
                }
            };
            void getUserDetails();
        }
    }, [roleName, userId]);



    useEffect(() => {
        const fetchUsers = async () => {
            try {

                const rolePriority = {
                    'HeadOfAgency': 1,
                    'DeputyHeadOfAgency': 2,
                    'HeadOfDepartment': 3,
                    'Expert': 4
                };

                internalUsers.sort((a, b) => {
                    if (rolePriority[a.roleName] !== rolePriority[b.roleName]) {
                        return rolePriority[a.roleName] - rolePriority[b.roleName];
                    } else {
                        return a.firstName.localeCompare(b.firstName);
                    }
                });

                if (roleName === "HEADOFAGENCY") {
                    setUserViewers(internalUsers);
                } else if (roleName === "DEPUTYHEADOFAGENCY") {
                    const deputyUsers = internalUsers.filter(user => user.roleName !== "DeputyHeadOfAgency")
                    setUserViewers(deputyUsers);
                } else {
                    const currentUser = internalUsers.find(user => user.id === userId);
                    let departmentUsers = [];
                    let headOfDepartments = [];

                    if (currentUser) {
                        departmentUsers = internalUsers.filter(user => user.departmentId === currentUser.departmentId && user.id !== userId);
                        headOfDepartments = internalUsers.filter(user => user.roleName === "HeadOfDepartment" && user.id !== userId);
                        const filteredUsers = [...departmentUsers, ...headOfDepartments.filter(hod => !departmentUsers.some(du => du.id === hod.id))];
                        setUserViewers(filteredUsers);
                    } else {
                    }
                }
            } catch (error) {
            }
        };
        void fetchUsers();
    },  [userId, roleName, token]);


    const formatUserViewerOptions = (users) => {
        return users.filter(user => selectedViewerDepartment === null || user.departmentId === selectedViewerDepartment)
            .map((user, index) => ({
                value: user.id,
                label: `${user.firstName} ${user.lastName} (${rolesInGeorgian[user.roleName]})`,
                roleName: user.roleName,
                isCheckedApprover: false,
                approverStatus: index === 0 ? approverStatusEnum.worker : approverStatusEnum.viewer
            }));
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        setShowConfirmationModal(true);
    };


    const handleConfirm = async () => {
        setLoading(true);
        let chatUsers = []
        const caseId = new URLSearchParams(window.location.search).get('id');
        const apiUrlViewer = `${process.env.REACT_APP_API_BASE_URL}/AddNewCaseUser`;

        try {
            const promises = selectedUserViewerOptions.map(option => {
                const payloadViewer = {
                    caseId: caseId ? parseInt(caseId, 10) : 0,
                    toUserId: option.value,
                    dedlineDays: null,
                    status: AddNewCaseViewerEnum.SentToAnotherDepartment,
                    addedBySystem: false,
                    caseUserType: CaseUserStatus.CaseViewer,
                    caseFileId: fileId,
                    approver: option.isCheckedApprover,
                    approverStatus: option.approverStatus,
                };
                chatUsers.push(payloadViewer.toUserId)
                return axios.post(apiUrlViewer, payloadViewer);
            });
            await Promise.all(promises);

            await Promise.all(selectedUserViewerOptions.map((viewer) => {
                const caseNotification = {
                    nextStepUserId: viewer.value,
                    caseId: caseId ? parseInt(caseId, 10) : 0,
                    documentId: null,
                    action: CaseNotificationEnum.added.id,
                    caseStatus: 8,
                    viewed: false,
                    role: viewer.approverStatus,

                };

                return  axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
            }));

            const chatUsersPayload = {
                chatName: groupId.chatName,
                chatUsersIds: [...groupId.chatUsersIds, ...chatUsers],
                id: groupId.id,
                caseNumber: groupId.caseNumber,
                caseID: groupId.caseID

            };

            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditChatGroup`, chatUsersPayload);

            setShowPopup(false);
            setAlertInfo({show: true, message: 'მენეჯერი წარმატებით დაემატა!', type: 'success'});
            onManagerAdded();
        } catch (error) {
            setAlertInfo({show: true, message: 'დაფიქსირდა შეცდომა!', type: 'error'});
        } finally {
            setLoading(false);
            setShowConfirmationModal(false);
        }
    };


    const userViewerOptions = formatUserViewerOptions(userViewers);
    const handleChangeUserViewer = (selectedValues) => {
        if (selectedUserViewerOptions.length === 0) {
            setSelectedUserViewerOptions(selectedValues.map(option => ({
                ...option,
                isChecked: false
            })));
        } else {
            const updatedValues = selectedValues.map(option => {
                const existingOption = selectedUserViewerOptions.find(o => o.value === option.value);
                return {
                    ...option,
                    isChecked: existingOption ? existingOption.isChecked : true
                };
            });
            setSelectedUserViewerOptions(updatedValues);
        }
    };

    return (
        <div>
            {showPopup && (
                <div className="overlay" onClick={() => setShowPopup(false)}></div>
            )}
            <Tooltip title={"შემსრულებლის დამატება"}>
                <div>
                    <FaUserPlus
                        onClick={() => setShowPopup(true)}
                        className="add-new-case-viewer-icon"
                    >
                    </FaUserPlus>
                </div>
            </Tooltip>


            {showPopup && (
                <div className="popup">
                    <form style={{ marginTop: 40}} onSubmit={handleSubmit} className="form-container-user-select">
                        <Select
                            style={{cursor: "pointer"}}
                            options={userViewerOptions.filter(user => user.roleName !== "HeadOfDepartment")}
                            className="search-select-popup"
                            placeholder="მოძებნეთ დამატებითი შემსრულებლი..."
                            isClearable
                            isSearchable
                            noOptionsMessage={() => "არაფერი მოიძებნა"}
                            isMulti
                            onChange={handleChangeUserViewer}
                            value={selectedUserViewerOptions}
                        />

                        {selectedUserViewerOptions.map((option) => (
                            <div className="checkbox-label-container" key={option.value}>
                                <label>{option.label}</label>
                                <div className="checkbox-group">
                                    <div>
                                        <span className="checkbox-label">შემსრულებელი</span>
                                        <Checkbox
                                            checked={option.approverStatus === approverStatusEnum.worker}
                                            onChange={() => handleChangeCheckbox(option.value, approverStatusEnum.worker)}
                                            color="primary"
                                        />
                                    </div>
                                    <div>
                                        <span className="checkbox-label">ვიზატორი</span>
                                        <Checkbox
                                            checked={ option.approverStatus === approverStatusEnum.visager}
                                            onChange={() => handleChangeCheckbox(option.value, approverStatusEnum.visager)}
                                            color="primary"
                                        />
                                    </div>
                                    <div>
                                        <span className="checkbox-label">მეორადი შემსრულებელი</span>
                                        <Checkbox
                                            checked={option.approverStatus === approverStatusEnum.viewer}
                                            onChange={() => handleChangeCheckbox(option.value, approverStatusEnum.viewer)}
                                            color="primary"
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}


                        {loading ? (
                            <div className="loader"></div>
                        ) : (
                            <Tooltip title={selectedUserViewerOptions.length === 0 ? "აირჩიეთ სპეციალისტი" :
                                selectedUserViewerOptions.every(option => option.approverStatus !== approverStatusEnum.worker) ? "აირჩიეთ შემსრულებელი"  : ""}>
                                <div>
                                <button
                                    type="submit"
                                    className="submit-button"
                                    disabled={selectedUserViewerOptions.length === 0 || selectedUserViewerOptions.every(option => option.approverStatus !== approverStatusEnum.worker)}
                                >
                                    დამატება
                                </button>
                                </div>
                            </Tooltip>


                        )}
                    </form>
                    <IoIosCloseCircle className="upload-single-close-icon"
                                      onClick={() => setShowPopup(false)}
                    />
                </div>
            )}
            <ConfirmationModal
                isOpen={showConfirmationModal}
                onRequestClose={() => setShowConfirmationModal(false)}
                onConfirm={handleConfirm}
            />
            {alertInfo.show && (
                <CustomAlert
                    message={alertInfo.message}
                    type={alertInfo.type}
                    onClose={() => setAlertInfo({show: false, message: '', type: ''})}
                />
            )}
        </div>
    );
};

export default AddressingPopupViewer;


